import dayjs, { extend } from "dayjs";
import utc from "dayjs/plugin/utc";

extend(utc);

// Время дилера — Казахстан: с 1 марта 2024 единый пояс UTC+5, перевода часов нет.
//
// Раньше здесь была зона «Asia/Almaty» через dayjs/plugin/timezone. Смещение
// для неё берётся из tz-базы среды, а не из кода: у node 14 на тест-сервере
// (tz 2021a) и на раннере CI Алматы ещё GMT+6, и время записи уезжало на час —
// 05:30 показывалось как 06:30, тесты recordDate падали. Фиксированное
// смещение считается одинаково в любом браузере и на любом node.
const DEALER_UTC_OFFSET_MINUTES = 5 * 60;

function fixDateTimezone(date, utcOffsetMinutes = DEALER_UTC_OFFSET_MINUTES) {
  return dayjs(date).utc().utcOffset(utcOffsetMinutes);
}

export default fixDateTimezone;
